import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirRelatedService } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirRelatedServicesAdapter = createEntityAdapter<JSONApiDataObject<BsdirRelatedService>>({
  selectId: item => item.id
});

export const bsdirRelatedServicesSlice = createSlice({
  name: 'bsdirRelatedServices',
  initialState: bsdirRelatedServicesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirRelatedService>),
  reducers: {
    bsdirRelatedServicesAdded: (state, action) => {
      bsdirRelatedServicesAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirRelatedServicesSelectors = bsdirRelatedServicesAdapter.getSelectors(
  (state: RootState) => state.bsdir.relatedServices);
export default bsdirRelatedServicesSlice.reducer;
